<div class="d-flex align-items-center">
    <label class="switch" [ngClass]="{'disabled': disabled()}">
        <input
            data-id="toggle"
            (change)="toggle($event)"
            [checked]="checked()"
            [disabled]="disabled()"
            type="checkbox">
        <span class="slider round"></span>
    </label>
    <span data-id="label" class="ps-3">{{ label() }}</span>
</div>
